import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
const CameraLocationsDB = [

    {
        cameraLocationId: 'S06',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Amanda Seaborn',
        cameraPosition: new Vector3(-8.312, -0.500, -21.287), // use THREE.Vector3
        cameraRotation: new Euler(0.039, -1.286, 0.037),  //use THREE.Euler
    },
    {
        cameraLocationId: 'S07',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Bidushi Thapa',
        cameraPosition: new Vector3(10.159, -0.500, -18.309),
        cameraRotation: new Euler(-3.109, 1.204, 3.111),
    },

    {
        cameraLocationId: 'S14',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Cassius Hunt',
        cameraPosition: new Vector3(6.026, -0.500, -24.423),
        cameraRotation: new Euler(-3.134, -1.096, -3.135),
    },

    {
        cameraLocationId: 'S03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Del Singh',
        cameraPosition: new Vector3(8.409, -0.500, -0.024),
        cameraRotation: new Euler(-3.137, 0.928, 3.138),
    },

    {
        cameraLocationId: 'S11',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Ellery Lin',
        cameraPosition: new Vector3(7.643, -0.500, 21.749),
        cameraRotation: new Euler(3.129, 1.095, -3.130),
    },

    {
        cameraLocationId: 'S10',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Elsie Bryant',
        cameraPosition: new Vector3(8.518, -0.500, 21.080),
        cameraRotation: new Euler(-0.014, 0.935, 0.011),
    },

    {
        cameraLocationId: 'S01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Hedvika Marne',
        cameraPosition: new Vector3(-8.314, -0.500, 21.526),
        cameraRotation: new Euler(0.000, -0.773, 0.000),
    },
    {

        cameraLocationId: 'S04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Hilary Barnes',
        cameraPosition: new Vector3(-8.842, -0.500, -8.066),
        cameraRotation: new Euler(3.114, -1.158, 3.117),
    },
    {
        cameraLocationId: 'S02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Julia Woodhouse',
        cameraPosition: new Vector3(-8.546, -0.500, 11.844),
        cameraRotation: new Euler(-0.013, -0.883, -0.010),
    },
    {
        cameraLocationId: 'S12',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Liz Evans',
        cameraPosition: new Vector3(9.219, -0.500, 2.241),
        cameraRotation: new Euler(3.093, -0.263, 3.129),
    },
    {
        cameraLocationId: 'S08',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Rainless Chang',
        cameraPosition: new Vector3(10.149, -0.500, -2.738),
        cameraRotation: new Euler(-0.046, 1.278, 0.044),
    },
    {
        cameraLocationId: 'S05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Rita Krupaviciute',
        cameraPosition: new Vector3(-5.359, -0.500, -17.595),
        cameraRotation: new Euler(3.128, -0.618, 3.134),
    },
    {
        cameraLocationId: 'S13',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Saif Chawdhury',
        cameraPosition: new Vector3(8.508, -0.500, -0.004),
        cameraRotation: new Euler(0.030, -0.497, 0.014),
    },
    {
        cameraLocationId: 'S09',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Vika Cheng',
        cameraPosition: new Vector3(9.151, -0.500, 4.152),
        cameraRotation: new Euler(-3.104, 1.212, 3.106),
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
